<script>
    import 'firebase/auth';
    import { getContext } from 'svelte';

    const auth = getContext('firebase').getFirebase().auth();

    let email = '';

    let errorMessage = '';
    let successMessage = '';
    $: disabled = !email;

    async function sendResetEmail() {
        if (disabled) {
            return;
        }
        auth.sendPasswordResetEmail(email).then(function() {
            errorMessage = '';
            successMessage = 'Password reset email sent!';
        }).catch((error) => {
            successMessage = '';
            errorMessage = 'Email address is invalid.';
        });
    }
</script>

<h2>Forgot Password</h2>
<div class='form-wrapper'>
    <form on:submit|preventDefault={sendResetEmail}>
        <input bind:value={email} type='text' placeholder='Email'>
        <input type='submit' value='Send Reset Email' disabled={disabled}>
    </form>
    {#if successMessage}
        <div class='form-success-message'>
            <span>{successMessage}</span>
        </div>
    {/if}
    {#if errorMessage}
        <div class='form-error-message'>
            <span>{errorMessage}</span>
        </div>
    {/if}
</div>

<style>
    h2 {
        text-align: center;
        padding-bottom: 15px;
    }

    input[type=text] {
        width: 100%;
    }

    input[type=text] {
        margin: 0px 0px 10px 0px;
    }

    input[type=submit] {
        margin-top: 10px;
    }

    input[type=submit]:hover {
        cursor: pointer;
    }

    input[type=submit]:disabled {
        background-color: var(--grey);        
    }
</style>
